module.exports = __webpack_public_path__ + "static/media/4.0fc25452.jpg";